import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  const navigate = useNavigate();
  // Create a custom theme with your color
  const theme = createTheme({
    palette: {
      primary: {
        main: "#8adbd3",
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: "6rem",
        fontWeight: 700,
        letterSpacing: "-0.01562em",
      },
      h4: {
        fontWeight: 500,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 2,
              textAlign: "center",
              width: "100%",
            }}
          >
            <ErrorOutlineIcon color="primary" sx={{ fontSize: 70, mb: 2 }} />
            <Typography variant="h1" color="primary" gutterBottom>
              404
            </Typography>
            <Typography variant="h4" gutterBottom>
              Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              The page you are looking for doesn't exist or has been moved.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<HomeIcon />}
              sx={{ mt: 3, textTransform: "none", fontWeight: 500 }}
              onClick={() => navigate("/")}
            >
              Back to Home
            </Button>
          </Paper>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
